import React from 'react';
import { Quote } from '../components';
import { Typography } from '@/components/common';

interface Props {
	name: string;
	text: string;
}

export const CardTestimonialLarge: React.FC<Props> = ({ text, name }) => {
	return (
		<div className="flex flex-col items-center justify-center h-full">
			<div className="flex flex-col lg:flex-row items-start justify-center gap-6 lg:gap-10 relative">
				<Quote />
				<Typography
					type="regular-20"
					className="!text-base lg:!text-[22px] max-w-[732px] !text-[#6E6A73]"
				>
					{text}
				</Typography>
				<Typography
					type="semibold-20"
					className="lg:absolute -bottom-[52px] left-[106px]"
				>
					{name}
				</Typography>
			</div>
		</div>
	);
};
